// extracted by mini-css-extract-plugin
export default {"main":"VendorMain_main__Bysxt","aside":"VendorMain_aside__usJ8Z","article":"VendorMain_article__al-MQ"};